import BaseService from './BaseService';
import RequestPool from './RequestPool';
import legacyUtils from './utils';

const defaultEndpoints = {
  me: '/me',
  loginWithGoogle: '/login/google',
  logout: '/logout',
};

export default class UserService extends BaseService {
  meRequestPool: RequestPool;

  constructor(endpoints: any, forceAgentHeader = false) {
    super(legacyUtils.mergeObjects(defaultEndpoints, endpoints), forceAgentHeader);

    this.meRequestPool = new RequestPool();
  }

  setToken(token) {
    localStorage.setItem('token', token);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  delToken() {
    localStorage.removeItem('token');
  }

  _makeAuthRequest(method, path, body, headers, callback) {
    const token = this.getToken();

    if (!token) {
      return callback(new Error('No access token. Login required.'));
    }

    headers = headers || {};
    headers.Authorization = 'Bearer ' + token;
    super._makeRequest(method, path, body, headers, callback);
  }

  _unwrapAccountResult(callback) {
    return (err, result) => {
      if (err) {
        return callback(err);
      }

      callback(null, result.account || result || {});
    };
  }

  me(callback) {
    this.meRequestPool.request((resultCallback) => {
      this._makeAuthRequest('get', this.endpoints.me, null, null, this._unwrapAccountResult(resultCallback));
    }, callback);
  }

  updateProfile(data, callback) {
    this._makeAuthRequest('post', this.endpoints.me, data, null, callback);
  }

  loginWithGoogle(options, callback) {
    this._makeRequest('post', this.endpoints.loginWithGoogle, options, null, (err, response) => {
      if (err) {
        return callback(err);
      }

      this.setToken(response.result.access_token);
      this._unwrapAccountResult(callback(null, response));
    });
  }

  logout(callback) {
    if (this.getToken()) {
      this._makeAuthRequest('post', this.endpoints.logout, null, null, callback);
    } else {
      this._makeRequest('post', this.endpoints.logout, null, null, callback);
    }

    this.delToken();
  }
}
